import {axiosInstance} from "./base"


export function getUsersQry(params) { // FIXME duplicated
  return axiosInstance.get("api/users/", {params})
}

export function patcherUserQry(id, data, params) {
  return axiosInstance.patch(`api/users/${id}/`, data, {params})
}

export function deleteUserQry(id, params) {
  return axiosInstance.delete(`api/users/${id}/`, {params})
}

export function sendSms(params) { // Fixme naming
  return axiosInstance.post(`api/users/send-sms/`, params)
}

export function postValidateUserQry(id) {
  return axiosInstance.post(`/api/users/${id}/validate-user-registration/`)
}
